import React from 'react';
import PropTypes from 'prop-types';

const styles = {
	links: { color: '#284263' },
}

const CHEurField = ({ source, source_disp, record = {} }) => <span>€ {record[source]}</span>;

CHEurField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CHEurField;


// WEBPACK FOOTER //
// ./src/utils/CHEurField.js